import { Navigate, Outlet } from "react-router-dom";

function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}

export default function ProtectedRoute() {
  const token = localStorage.getItem("xtm_token");

  if (!token || isTokenExpired(token)) {
    if (token) localStorage.removeItem("xtm_token");
    return <Navigate to="/sign-in" replace />;
  }

  return <Outlet />;
}
